import { Stack, Typography, FormGroup, FormControl, InputLabel, Select, MenuItem, TextField } from "@mui/material";
import { ScheduleMonth, ScheduleMonthMode } from "../../../../../types/actionModule/schedulingStrategy/schedulingStrategyType";
import { ScheduleWeeksDefinitionEditorProps, ScheduleWeeksDefinitionEditor } from "./ScheduleWeeksDefinitionEditor";
import { useTranslation } from "react-i18next";

export interface ScheduleMonthsDefinitionEditorProps extends ScheduleWeeksDefinitionEditorProps {
    monthModel: ScheduleMonth;
    onUpdateMonthModel: (value: ScheduleMonth) => void;
}

export function ScheduleMonthsDefinitionEditor(props: ScheduleMonthsDefinitionEditorProps) {
    const { t } = useTranslation();

    return <Stack sx={{ pt: 4 }}>
        <Typography variant="subtitle2">{t("actionModules.schedulingStrategy.scheduleDefinition.months.title")}</Typography>
        <Typography variant="caption">{t("actionModules.schedulingStrategy.scheduleDefinition.months.description")}</Typography>
        <FormGroup sx={{ flexDirection: "row", gap: 2, pt: 1 }}>
            <FormControl sx={{ minWidth: 250, flex: 1 }}>
                <InputLabel>{t("actionModules.schedulingStrategy.scheduleDefinition.months.scheduleMode.name")}</InputLabel>
                <Select
                    value={props.monthModel.mode}
                    size="small"
                    fullWidth
                    label={t("actionModules.schedulingStrategy.scheduleDefinition.months.scheduleMode.name")}
                    onChange={(v) => props.onUpdateMonthModel({
                        ...props.monthModel,
                        mode: v.target.value as ScheduleMonthMode,
                    })}
                >
                    <MenuItem value={ScheduleMonthMode.None}>{t("actionModules.schedulingStrategy.scheduleDefinition.months.scheduleMode.none")}</MenuItem>
                    <MenuItem value={ScheduleMonthMode.Repeat}>{t("actionModules.schedulingStrategy.scheduleDefinition.months.scheduleMode.repeat")}</MenuItem>
                    <MenuItem value={ScheduleMonthMode.Skip}>{t("actionModules.schedulingStrategy.scheduleDefinition.months.scheduleMode.skip")}</MenuItem>
                </Select>
            </FormControl>
            {
                props.monthModel.mode === ScheduleMonthMode.Skip &&
                <TextField
                    value={props.monthModel.value}
                    type="number"
                    onChange={(e) => props.onUpdateMonthModel({
                        ...props.monthModel,
                        value: Number(e.target.value)
                    })}
                    size="small"
                    sx={{ minWidth: 100, flex: 1 }}
                    label={t("actionModules.schedulingStrategy.scheduleDefinition.months.scheduleMode.value")} />
            }
        </FormGroup>
        <TextField
            value={props.monthModel.weekOffsetInsideMonth}
            type="number"
            onChange={(e) => props.onUpdateMonthModel({
                ...props.monthModel,
                weekOffsetInsideMonth: Number(e.target.value)
            })}
            size="small"
            sx={{ minWidth: 100, flex: 1, mt: 1 }}
            label={t("actionModules.schedulingStrategy.scheduleDefinition.months.offset")} />

        <ScheduleWeeksDefinitionEditor
            weekModel={props.weekModel}
            onUpdateWeekModel={props.onUpdateWeekModel}
            dayModel={props.dayModel}
            onUpdateDayModel={props.onUpdateDayModel}
        />
    </Stack>
}
